// Nomes normalizados a partir dos polígonos do arquivo "Bairros Garça.kmz".
export const RURAL_NEIGHBORHOODS = [
  '200 Alqueires',
  '9 de Julho',
  'Aeroporto',
  'Água da Prata / Adrianita',
  'Alto Alegre',
  'Antinhas',
  'Bandeirantes',
  'Boteco Azul',
  'Cachoeira',
  'Cascata',
  'Corredeira',
  'Itiratupã',
  'Jabuticabeira',
  'Kaikan',
  'Maristela',
  'Ouro Branco',
  'Quatro Covas',
  'Rio da Garça',
  'Roça Grande',
  'Santa Avelina',
  'Santa Cecília',
  'Santo André',
  'São João do Rio do Peixe',
  'São José',
  'Sasazaki',
  'Torrão de Ouro',
  'Venda Seca',
]
